"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePreference = void 0;
/*
 * Copyright 2026, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const react_1 = __importDefault(require("react"));
/**
 * Subscribes to a single user preference, keeping the returned value in sync
 * across every component using it. The setter persists the new value to the
 * server.
 *
 * @param path Dot-separated path to the preference
 * @param defaultValue Value to return when the preference is not set
 * @returns A [value, setValue] tuple, similar to useState
 */
const usePreference = (path, defaultValue) => {
    const subscribe = react_1.default.useCallback((onStoreChange) => {
        Preferences_1.default.addChangeListener(onStoreChange);
        return () => Preferences_1.default.removeChangeListener(onStoreChange);
    }, []);
    const getSnapshot = react_1.default.useCallback(() => Preferences_1.default.get(path, defaultValue), [path, defaultValue]);
    const value = react_1.default.useSyncExternalStore(subscribe, getSnapshot);
    const setValue = react_1.default.useCallback((newValue) => {
        Preferences_1.default.update({ [path]: newValue }, ServiceLocator_1.default.socketEventManager);
    }, [path]);
    return [value, setValue];
};
exports.usePreference = usePreference;
exports.default = exports.usePreference;
//# sourceMappingURL=usePreference.js.map